var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEyUExURQAAAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAPsAAPsAAPsAAP8AAPsAAP8AAP8AAP8AAP8AAP8AAP0AAP8AAP0AAP8AAP8AAP0AAP0AAP0AAP0AAP8AAP4AAP4AAP4AAP4AAP4AAP4AAP8AAP4AAP4AAP4AAP8AAP8AAP4AAP8AAP8AAP4AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP4AAP4AAP4AAP8AAP4AAP4AAP8AAP4AAP8AAP4AAP4AAP8AAP8AAP8TE/8UFP8XF/8aGv8cHP8eHv80NP86Ov8/P/9LS/9OTv9SU/9kZP9qav+Skv+YmP+7u/+/v//f3//j4//s7P/t7f/y8v/+/v///2fB1ggAAABMdFJOUwACAwQFBgcICQoODxIUFRcaGzo+P0BAQkR+f4OHiImKiouOpKaprLS2t7m7vsDIyszN0NHR0tPU1dbX2Nna2+Pk5vLz+fr6+/v8/v7uWoy5AAAACXBIWXMAAA7DAAAOwwHHb6hkAAABAklEQVQoU7WSWVPCMBhFLxUVLRUUd9xwxV3BCjZUEEGURsV93+3//wtmOnccIb5yns7NnSSTyYd2YvSYUavPivZGDK4ojMHJ+dXNjJ13hCgIsZe3Mxsrc8mBEBAer8p/8CpjYSQ8pla8BKaoOjNYouksI0uTsnFNIbso0qS8+nhqUAMOUKap7tt/ezhlUByiRgs633+5O2OUJ6jT2Plft4yy3rrv9f6cUdaa73t//D1RyjJKNNV9Pl9SA0p/3ndxQyFZpGk6aaRoOikM03RG0Jk8ojfhHU90qX8fml5Y29rJOaLg7ruucHL29vri7GgH5wIIdZtWLN4fj1lmRE1DmwB+AP9gj9ld66TfAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img0"
  }), /*#__PURE__*/React.createElement("pattern", {
    width: 27,
    height: 27,
    patternUnits: "userSpaceOnUse",
    id: "pattern1",
    overflow: "hidden",
    patternTransform: "matrix(0.986707 0 0 0.986707 8.46414 8.3252)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.4306 21.6459C43.4306 33.6006 33.7394 43.2918 21.7847 43.2918 9.83 43.2918 0.138798 33.6006 0.138798 21.6459 0.138798 9.6912 9.83 7.26318e-07 21.7847 7.26318e-07 33.7394 7.26318e-07 43.4306 9.6912 43.4306 21.6459Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46414 8.3252 35.1052 8.3252 35.1052 34.9663 8.46414 34.9663Z",
    fill: "url(#pattern1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture5);
export default __webpack_public_path__ + "static/media/Picture5.efea81439831c1deebe38d4161b02394.svg";
export { ForwardRef as ReactComponent };